import { ensureRunsOnce } from 'helpers/singletons/ensureRunsOnce';
import { useLayoutEffect, useState } from 'react';
import { getAfterpayCheckoutWidgetScriptUrl, isNotServerSideRendering } from 'helpers/env';
type AfterPayWidgetOptions = {
  amount: {
    amount: string;
    currency: string;
  };
  target: string;
  locale: string;
  onReady: (event: any) => void;
  onChange: (event: any) => void;
  onError: (event: any) => void;
};
declare global {
  const AfterPay: AfterPay; // defines the global Yotpo object
  interface AfterPay {
    Widgets: {
      PaymentSchedule: (options: AfterPayWidgetOptions) => void;
    };
  }
}
interface UseAfterpayCheckoutWidgetScript {
  isWidgetReady: boolean;
  createCheckoutWidget: (selector: string, total: string) => void;
}

export const useAfterpayCheckoutWidgetScript = (): UseAfterpayCheckoutWidgetScript => {
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  const createCheckoutWidget = (selector: string, total: string) => {
    if (!window.AfterPay) {
      return;
    }
    window.afterpayWidget = new AfterPay.Widgets.PaymentSchedule({
      amount: {
        amount: total,
        currency: 'USD'
      },
      target: selector,
      locale: 'en-US',
      onReady: function(event) {
        console.log('afterpay: ready');
      },
      onChange: function(event) {
        console.log('afterpay: update');
      },
      onError: function(event) {
        console.log('Afterpay Widget error event: ', event);
      }
    });
  };

  useLayoutEffect(() => {
    ensureRunsOnce(async () => {
      const checkoutWidgetScript = document.createElement('script');
      checkoutWidgetScript.type = 'text/javascript';
      checkoutWidgetScript.async = true;
      checkoutWidgetScript.src = getAfterpayCheckoutWidgetScriptUrl();

      if (isNotServerSideRendering() && window) {
        if (window.AfterPay) {
          setIsWidgetReady(true);
          return;
        }

        window.addEventListener('AfterPay.ready', () => {
          setIsWidgetReady(true);
        });
      }

      const loadScript = new Promise<void>((resolve, reject) => {
        checkoutWidgetScript.onload = () => {
          setIsWidgetReady(true);
          resolve();
        };
        checkoutWidgetScript.onerror = reject;
      });

      setTimeout(() => {
        const sibling = document.getElementsByTagName('script')[0];
        sibling.parentNode.insertBefore(checkoutWidgetScript, sibling);
      }, 0);

      return loadScript;
    })();
  }, []);

  return {
    isWidgetReady,
    createCheckoutWidget
  };
};
